import { render, staticRenderFns } from "./DownCowMeta.vue?vue&type=template&id=552b6542&"
import script from "./DownCowMeta.vue?vue&type=script&lang=js&"
export * from "./DownCowMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports